import {
    SET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS,
    RESET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS
} from './constants';

type State = null;

type Action = {
    type: string;
    payload: any;
};

const initialState = null;

export default function (state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS:
            return action.payload.errors;
        case RESET_TIMESHEET_TIMESHEET_ENTRIES_API_ERRORS:
            return initialState;
        default:
            return state;
    }
}
